export default {"src":"/_next/static/media/group-order-icon.141ec2d1.svg","height":17,"width":18};